import React, { useContext, useState } from 'react'
import { Formik } from 'formik';
import * as yup from "yup";
import { Box, Button, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { AdminContext } from '../../../context/AdminContext';
import { tokens } from '../../../theme';

const languagePrefixes = {
    turkish: "tr",
    french: "fr",
    german: "de",
    italian: "it",
    portuguese: "pt",
    spanish: "sp"
}


function PlayWinSectionDialog({ dialogOpen, handleClose, settings, fetchSettings }) {

    const { token } = useContext(AdminContext);
    const colors = tokens();

    var initialValues = {
        play_win_content: null,
        play_win_title: settings && settings[languagePrefixes["turkish"] + "_play_win_title"] ? settings[languagePrefixes["turkish"] + "_play_win_title"] : "",
        play_win_description: settings && settings[languagePrefixes["turkish"] + "_play_win_description"] ? settings[languagePrefixes["turkish"] + "_play_win_description"] : "",
        play_win_action_text: settings && settings[languagePrefixes["turkish"] + "_play_win_action_text"] ? settings[languagePrefixes["turkish"] + "_play_win_action_text"] : "",
        play_win_action_link: settings && settings[languagePrefixes["turkish"] + "_play_win_action_link"] ? settings[languagePrefixes["turkish"] + "_play_win_action_link"] : "",
        language: "turkish"
    }

    var validationObject = {
        play_win_content: yup.mixed().nullable().notRequired(),
        play_win_title: yup.string().required("required"),
        play_win_description: yup.string().required("required"),
        play_win_action_text: yup.string().required("required"),
        play_win_action_link: yup.string().required("required"),
        language: yup.string().required("required")
    }

    const settingsSchema = yup.object().shape(validationObject);

    const handleFormSubmit = async (values) => {
        let playWinSectionSettings = { ...values };
        if (playWinSectionSettings.play_win_content) {
            await axios.post(`${process.env.REACT_APP_API_URL}settings/uploadPlayWinImage?token=${token}`, {
                playWinImage: values.play_win_content
            }, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .catch((err) => {
                    console.log("err: " + err);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 201) {
                        playWinSectionSettings.play_win_content_path = response.data.imagePath;
                    }
                });
        }
        delete playWinSectionSettings.play_win_content;
        await axios.patch(`${process.env.REACT_APP_API_URL}settings/updatePlayWinSection`, {
            ...playWinSectionSettings
        }).catch((err) => {
            console.log("err: " + err);
        }).then((response) => {
            if (response && response.data.success === true && response.data.status === 200) {
                fetchSettings();
                handleClose();
            }
        });
    }

    return (
        <Dialog
            sx={{ margin: "0 auto" }} open={dialogOpen}
            onClose={handleClose}>
            <Box m="20px" mx="150px" textAlign="center">
                <Typography variant='h3'>
                    Home Page Featured Section Settings
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={settingsSchema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box textAlign="center">
                                    <Typography variant="h6">Image</Typography>
                                    <Button variant="contained" component="label" style={{ textAlign: "center", background: colors.grey[900], height: "150px", width: "180px" }}>
                                        {(values.play_win_content || (settings?.play_win_content_link && settings?.play_win_content_link !== "")) && <img alt='word' width="100px" src={values.play_win_content ? URL.createObjectURL(values.play_win_content) : settings?.play_win_content_link} />}
                                        <input id="play_win_content" name="play_win_content" type="file" accept=".png, .jpeg, .jpg" onChange={(event) => { setFieldValue("play_win_content", event.target.files[0]); }} hidden />
                                    </Button>
                                </Box>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(2, minmax(0, 1fr))" my="25px">
                                    <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 2", marginTop: "10px" }}>
                                        <InputLabel id="filter-label">Language</InputLabel>
                                        <Select
                                            labelId="filter-label"
                                            label="Language"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                setFieldValue("language", e.target.value);
                                                setFieldValue("play_win_title", settings[languagePrefixes[e.target.value] + "_play_win_title"]);
                                                setFieldValue("play_win_description", settings[languagePrefixes[e.target.value] + "_play_win_description"]);
                                                setFieldValue("play_win_action_text", settings[languagePrefixes[e.target.value] + "_play_win_action_text"]);
                                            }}
                                            name={"language"}
                                            value={values.language}
                                            error={!!touched.language && !!errors.language}
                                        >
                                            <MenuItem value={"turkish"}>Turkish</MenuItem>
                                            <MenuItem value={"french"}>French</MenuItem>
                                            <MenuItem value={"german"}>German</MenuItem>
                                            <MenuItem value={"spanish"}>Spanish</MenuItem>
                                            <MenuItem value={"portuguese"}>Portuguese</MenuItem>
                                            <MenuItem value={"italian"}>Italian</MenuItem>
                                        </Select>
                                    </FormControl>

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Title"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"play_win_title"}
                                        value={values.play_win_title}
                                        error={!!touched.play_win_title && !!errors.play_win_title}
                                        helperText={touched.play_win_title && errors.play_win_title}
                                        sx={{ gridColumn: "span 2", marginTop: "10px" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Description"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"play_win_description"}
                                        rows={4}
                                        multiline
                                        value={values.play_win_description}
                                        error={!!touched.play_win_description && !!errors.play_win_description}
                                        helperText={touched.play_win_description && errors.play_win_description}
                                        sx={{ gridColumn: "span 2", marginTop: "10px" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Button Text"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"play_win_action_text"}
                                        value={values.play_win_action_text}
                                        error={!!touched.play_win_action_text && !!errors.play_win_action_text}
                                        helperText={touched.play_win_action_text && errors.play_win_action_text}
                                        sx={{ gridColumn: "span 2", marginTop: "10px" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Button Link"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"play_win_action_link"}
                                        value={values.play_win_action_link}
                                        error={!!touched.play_win_action_link && !!errors.play_win_action_link}
                                        helperText={touched.play_win_action_link && errors.play_win_action_link}
                                        sx={{ gridColumn: "span 2", marginTop: "10px" }}
                                    />
                                </Box>
                                <Box display="flex" justifyContent="end" m="30px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Save</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default PlayWinSectionDialog